// SortContent.js

import React, { useState, useEffect } from 'react';
import { Radio, Divider, Button } from 'antd';
import {
  SortAscendingOutlined,
  SortDescendingOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';

const WorkstreamActionSortContent = ({
  sortOrder,
  handleSortOrderChange,
  sortField,
  handleSortChange,
}) => {
  const [isClearVisible, setIsClearVisible] = useState(false);

  const handleClear = () => {
    handleSortChange('None');
  };

  useEffect(() => {
    setIsClearVisible(sortField !== 'None' && sortField !== null && sortOrder !== null);
  }, [sortField, sortOrder]);
  return (
    <>
      <div style={{ marginBottom: '10px', position: 'fixed' }}>
        <Radio.Group value={sortOrder} onChange={handleSortOrderChange}>
          <Radio value="asc" checked>
            <SortAscendingOutlined />
            Ascending
          </Radio>
          <Radio value="desc">
            <SortDescendingOutlined />
            Descending
          </Radio>
        </Radio.Group>
      </div>
      <Divider style={{ margin: '10px 0' }} />
      <div
        style={{
          padding: '10px',
          maxHeight: '500px',
          overflowY: 'auto',
          backgroundColor: 'whitesmoke',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
          {isClearVisible && (
            <Button
              type="text"
              onClick={handleClear}
              style={{ padding: 0, color: 'blue' }}
              icon={<CloseCircleOutlined />}
            >
              Clear
            </Button>
          )}
        </div>
        <div style={{ marginTop: '50px' }}>
          <Radio.Group onChange={(e) => handleSortChange(e.target.value)} value={sortField}>
            <div>
              <Radio value="none">None</Radio>
            </div>
            <div>
              <Radio value="actionItemNumber">#</Radio>
            </div>
            <div>
              <Radio value="workstreamActionName">Name</Radio>
            </div>
            <div>
              <Radio value="Accountable Workstream">Accountable Workstream</Radio>
            </div>
            <div>
              <Radio value="Accountable Subworkstream">Accountable Subworkstream</Radio>
            </div>
            <div>
              <Radio value="owner">Workstream Action Owner</Radio>
            </div>
            <div>
              <Radio value="status">Status</Radio>
            </div>
            <div>
              <Radio value="source">Source</Radio>
            </div>
            <div>
              <Radio value="Action planning summary">Planning summary</Radio>
            </div>
            <div>
              <Radio value="Created on">Created on</Radio>
            </div>
            <div>
              <Radio value="createdBy">Created by</Radio>
            </div>
            <div>
              <Radio value="Updated on">Updated on</Radio>
            </div>
            <div>
              <Radio value="actionUpdatedBy">Updated by</Radio>
            </div>
          </Radio.Group>
        </div>
      </div>
    </>
  );
};

export default WorkstreamActionSortContent;
